import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable()
export class SectionLinkService {
  readonly document = inject(DOCUMENT);

  goToSection(id: string) {
    const section = this.document?.querySelector(`#${id}`);
    if (!section) {
      console.warn(`Section with id ${id} not found`);
      return;
    }

    section.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}
